import Page404 from "./404Page";
import { Result } from "antd";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  if (error?.status === 404) return <Page404 />
  return (
    <Result
      title="Oops!"
      subTitle="Sorry, an unexpected error has occurred."
      extra={<i>{error.statusText || error.message}</i>}
    />
  );
}